const getroutingGuidelistBySearch = {
  // UserType: "ALL",
  // ClientCode: "**",
  // OriginCity: null,
  // OriginCountryCode: null,
  // OriginPortKey: 0,
  // OriginPostalFrom: null,
  // OriginStateCode: null,
  // DestinationCity: null,
  // DestinationCountryCode: null,
  // DestinationPortKey: 0,
  // DestinationPostalFrom: null,
  // DestinationStateCode: null,
  // ServiceLevel: null,
  // ShipmentDate: null,
  // Weight: 0.0,
  // WeightUOM: null,
  // CargoType: null,
  // Pieces: 0,
  // PiecesUOM: null,
  // CarrierKey: 0,
  // BranchKey: "-1",
  // Hazmat: false,
  // VendorKey: 0,
  // ShipmentType: null,
  // ServiceKey: 0,
  // RoutingKey: 0,
  PageSize: 10,
  PageNo: 1,
};

export default getroutingGuidelistBySearch;
